// Feature flags for UI components
const isEnabled = (value: string | boolean | undefined): boolean => {
  if (typeof value === 'boolean') return value;
  if (!value) return false;
  return value.toLowerCase() === 'true';
};

export const DEVICE_FEATURES = {
  SHOW_USER_MANAGEMENT: false, // Controls visibility of user management and status fields
  SHOW_SEQUENCE_MANAGER: isEnabled(import.meta.env.FEATURE_FLAG_SEQUENCE_MANAGER),
};
